import Repository from "./Repository";
import {
  CancellationWorkflowConfigurationDto,
  CouponRetentionRuleDto,
  ClaimRetentionOfferDto,
  ClaimRetentionOfferResultDto,
  GetCancellationWorkflowConfigurationDto,
  GetCouponRetentionRuleDto,
  RetentionEmailSubmissionResultDto,
  RetentionReportEntryDto,
  SaveCancellationWorkflowConfigurationsDto,
  SaveCouponRetentionRuleDto,
  SubmitCancellationFeedbackDto,
  SubmitFeatureRequestDto,
  SubmitSupportCallRequestDto,
  TrackRetentionAttemptDto,
} from "@/models/CancellationWorkflow";
import { MethodResult } from "./ResultTypes/MethodResult";
import { AxiosResponse } from "axios";

const resource = "/CancellationWorkflow";

export default {
  saveConfigurations(payload: SaveCancellationWorkflowConfigurationsDto) {
    return Repository.post(`${resource}/SaveCancellationWorkflowConfigurations`, payload, { withCredentials: true });
  },
  getConfiguration(payload: GetCancellationWorkflowConfigurationDto): Promise<AxiosResponse<MethodResult<CancellationWorkflowConfigurationDto>>> {
    return Repository.post(`${resource}/GetCancellationWorkflowConfiguration`, payload, { withCredentials: true });
  },
  getCouponRetentionRule(payload: GetCouponRetentionRuleDto): Promise<AxiosResponse<MethodResult<CouponRetentionRuleDto>>> {
    return Repository.post(`${resource}/GetCouponRetentionRule`, payload, { withCredentials: true });
  },
  saveCouponRetentionRule(payload: SaveCouponRetentionRuleDto) {
    return Repository.post(`${resource}/SaveCouponRetentionRule`, payload, { withCredentials: true });
  },
  trackRetentionAttempt(payload: TrackRetentionAttemptDto): Promise<AxiosResponse<MethodResult<number>>> {
    return Repository.post(`${resource}/TrackRetentionAttempt`, payload, { withCredentials: true });
  },
  claimRetentionOffer(payload: ClaimRetentionOfferDto): Promise<AxiosResponse<MethodResult<ClaimRetentionOfferResultDto>>> {
    return Repository.post(`${resource}/ClaimRetentionOffer`, payload, { withCredentials: true });
  },
  submitFeatureRequest(payload: SubmitFeatureRequestDto): Promise<AxiosResponse<MethodResult<RetentionEmailSubmissionResultDto>>> {
    return Repository.post(`${resource}/SubmitFeatureRequest`, payload, { withCredentials: true });
  },
  submitSupportCallRequest(payload: SubmitSupportCallRequestDto): Promise<AxiosResponse<MethodResult<RetentionEmailSubmissionResultDto>>> {
    return Repository.post(`${resource}/SubmitSupportCallRequest`, payload, { withCredentials: true });
  },
  submitCancellationFeedback(payload: SubmitCancellationFeedbackDto): Promise<AxiosResponse<MethodResult<RetentionEmailSubmissionResultDto>>> {
    return Repository.post(`${resource}/SubmitCancellationFeedback`, payload, { withCredentials: true });
  },
  getRetentionReport(): Promise<AxiosResponse<MethodResult<RetentionReportEntryDto[]>>> {
    return Repository.get(`${resource}/GetRetentionReport`, { withCredentials: true });
  },
};
